// Checkout service for API calls
import { CheckoutData } from '../types';
import { fetchWithErrorHandling, guestPrefix } from './apiUtils';

export class CheckoutService {
  static async getCheckoutData(): Promise<CheckoutData> {
    try {
      // Try API first - use guest or authenticated endpoint based on auth state
      try {
        const endpoint = `/api/v2${guestPrefix()}/checkout`;
        const response = await fetchWithErrorHandling<{ data: CheckoutData }>(endpoint);
        return response.data;
      } catch (apiError) {
        console.warn('API not available, falling back to local data:', apiError);

        // Fall back to local JSON file
        try {
          const { default: localCheckoutData } = await import('../data/checkout.sample.data.json');
          return localCheckoutData as CheckoutData;
        } catch (localError) {
          console.error('Failed to load local checkout data:', localError);
          throw new Error('Unable to load checkout data from both API and local data.');
        }
      }
    } catch (error) {
      console.error('Failed to fetch checkout data:', error);
      throw new Error('Unable to load checkout data. Please try again later.');
    }
  }
}
